import { Button, Group, Modal, Text } from '@common/ui'
import React, { useState } from 'react'

type ConfirmationDialogProps = {
  title: string
  content: React.JSX.Element
  onConfirm: () => void
  disabled?: boolean
  triggerTestId?: string
  cancelTestId?: string
  confirmTestId?: string
  dialogTestId?: string
}

const ConfirmationDialog = ({
  title,
  content,
  onConfirm,
  disabled,
  triggerTestId,
  cancelTestId,
  confirmTestId,
  dialogTestId,
}: ConfirmationDialogProps) => {
  const [dialogOpen, setDialogOpen] = useState(false)

  return (
    <>
      <Button
        data-testid={triggerTestId}
        variant="subtle"
        color="negative"
        disabled={disabled}
        onClick={() => setDialogOpen(true)}
      >
        {content}
      </Button>
      <Modal
        data-testid={dialogTestId}
        opened={dialogOpen}
        onClose={() => setDialogOpen(false)}
        title="Confirm your action"
      >
        <Text>{title}</Text>
        <Group justify="flex-end" mt="md">
          <Button data-testid={cancelTestId} variant="default" onClick={() => setDialogOpen(false)}>
            Cancel
          </Button>
          <Button data-testid={confirmTestId} color="negative" onClick={onConfirm}>
            Confirm
          </Button>
        </Group>
      </Modal>
    </>
  )
}

export default ConfirmationDialog
